module.exports = __webpack_public_path__ + "static/media/save.f9c77b03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/save.svg
// module id = 845
// module chunks = 0